import { styled } from '~/styled'

export const TableHeaderCell = styled('th', {
  base: [
    'text-white',
    'font-body',
    'font-semibold',
    'leading-normal',
    'text-left',
    'align-middle',
    '[[colspan]]:text-center'
  ]
})

TableHeaderCell.displayName = 'TableHeaderCell'
